import { render, staticRenderFns } from "./ProductTable.html?vue&type=template&id=2dec021d&scoped=true&external"
import script from "./ProductTable.js?vue&type=script&lang=js&external"
export * from "./ProductTable.js?vue&type=script&lang=js&external"
import style0 from "./ProductTable.css?vue&type=style&index=0&id=2dec021d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec021d",
  null
  
)

export default component.exports